export default "__VITE_ASSET__TDJArFKQ__"